/**
 * Created by Administrador on 24/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('baseRatesCargo', {
                parent: 'app',
                url: '/baseRatesCargo',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "50"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRateCargo/baseRatesCargo.html',
                        controller: 'baseRatesCargoCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            baseRates: ['baseRateService','$stateParams',function(baseRateService,$stateParams){
                                return baseRateService.getBaseRates($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('baseRateCargoEdit', {
                parent: 'app',
                url: '/baseRateCargo/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/baseRateCargo/baseRateCargoEdit.html',
                        controller: 'baseRateCargoEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['baseRates']);
                            }],
                            baseRate: ['baseRateService','$stateParams', function(baseRateService,$stateParams){
                                return baseRateService.getBaseRate($stateParams.id);
                            }]
                        }
                    }
                }
            });
    }
})();
